import { AUDIO_LEVEL_THRESHOLD } from "../constants";

export function getAudioLevelPercentage(level: number) {
    return (level * 100) / AUDIO_LEVEL_THRESHOLD; // 0 to 100
}